<template>
  <v-btn :loading="dialogLoading" @click.prevent="doSubmit()" color="green" dark>
    <slot>Save</slot>
    <!-- default slot content: "Save" -->
  </v-btn>
</template>

<script>
export default {
  name: 'base-delete-button-vuex',
  props: {
    formData: {
      type: [Array, Object],
      default: []
    },
    module: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogLoading: false
    }
  },
  methods: {
    async doSubmit() {
      try {
        const validate = await this.$validator.validateAll()
        if (validate) {
          await this.doInsert()
          this.$store.commit(`${this.module}/UPDATE_DIALOG`, false)
          this.$emit('formData', [])
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    async doInsert() {
      try {
        const data = {
          ...this.formData,
          createdBy: localStorage.getItem('userid')
        }
        this.$store.dispatch(`${this.module}/insert`, data)
      } catch (error) {
        throw new Error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/BaseSubmitButton.vue